var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13C0 5.82 5.82 0 13 0s13 5.82 13 13-5.82 13-13 13S0 20.18 0 13zm8.059-5.291A34.22 34.22 0 0113 7.334c2.04 0 3.844.21 4.941.375a2.128 2.128 0 011.774 1.738c.144.79.285 1.942.285 3.387 0 1.441-.14 2.594-.281 3.387a2.137 2.137 0 01-1.778 1.738h-.003c-1.102.164-2.91.375-4.938.375-2.027 0-3.84-.211-4.941-.375a2.141 2.141 0 01-1.778-1.738C6.141 15.43 6 14.279 6 12.834s.14-2.598.281-3.387A2.136 2.136 0 018.06 7.71zM16 12.834l-5 2.5v-5l5 2.5z"
  })));
};
export default SvgYoutube;